// Components
import ContactBoxBlock from 'components/staticpages/blocks/contactboxblock'
import MediaBlock from 'components/staticpages/blocks/mediablock'
import NewsBlock from 'components/staticpages/blocks/newsblock'
import PageHeadingBlock from 'components/staticpages/blocks/pageheadingblock'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'

// Utils
import formatHtml from 'components/staticpages/formathtml'

import styles from './sidebarlayout.css'

type TextBlockProps = {
  value: string
}
const TextBlock = ({ value }: TextBlockProps): JSX.Element => (
  <div className={styles.textblock}>
    <div>
      <span dangerouslySetInnerHTML={{ __html: formatHtml(value) }} />
    </div>
  </div>
)

type SidebarLayoutBlockProps = {
  type: string
  value: string
}
const SidebarLayoutBlock = (props: SidebarLayoutBlockProps): JSX.Element => {
  const { type } = props
  switch (type) {
    case 'contact_box':
      return <ContactBoxBlock {...props} />
    case 'text':
      return <TextBlock {...props} />
    case 'news':
      return <NewsBlock {...props} />
    case 'media':
      return <MediaBlock {...props} />
    default:
      return <p>Unsupported type: {type}</p>
  }
}

const getLoginFilter = (isAuthenticated: boolean) => (block: { value: { loggedin_required?: boolean } }) => {
  const loginReqired = block.value.hasOwnProperty('loggedin_required') && block.value.loggedin_required
  if (isAuthenticated) {
    return loginReqired !== 2
  }
  return loginReqired !== 1
}

type SidebarLayoutProps = {
  title: string
  content: Array<Record<string, unknown>>
  sidebarContent: Array<Record<string, unknown>>
}

const SidebarLayout = ({ title, content, sidebarContent }: SidebarLayoutProps): JSX.Element => {
  const isAuthenticated = useIsAuthenticated()
  return (
    <div>
      {title && <PageHeadingBlock value={{ heading: title }} />}
      <div className={styles.container}>
        <div>
          <section>
            {content &&
              content.filter(getLoginFilter(isAuthenticated)).map((block, index) => (
                <div key={String(index)}>
                  <SidebarLayoutBlock type={block.type} value={block.value} />
                </div>
              ))}
          </section>
          <aside>
            <div className="sticky">
              {sidebarContent &&
                sidebarContent.filter(getLoginFilter(isAuthenticated)).map((block, index) => (
                  <div key={String(index)}>
                    <SidebarLayoutBlock type={block.type} value={block.value} />
                  </div>
                ))}
            </div>
          </aside>
        </div>
      </div>
    </div>
  )
}

export { SidebarLayout, SidebarLayoutBlock }
